export default __webpack_public_path__ + "static/media/profilePictureEdit.39ee2bbe.jpg";